import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';
import { QueryMediator } from './../../../vendor/utility-ng-kernel/dist/core/query_mediator';
import { College } from './../builders/college_builder';
import { Course } from './../builders/course_builder';
import { IDefineCommand, IQueryMediator, ICommand, IQuery } from 'core-ts-types';
import { TransferTransactionModel } from '../models/transfer_transaction_model';

angular.module('capability-ng-transfer').factory(
  'selectTransferCourseCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferCoursesDatasource: ITransferCoursesDatasource,
    $http: ng.IHttpService,
    transferMajorTileDelegate: any,
    ngTransferCourseTransactionModel: TransferTransactionModel
  ): ICommand => {
    return defineCommand(
      'selectTransferCourseCommand',
      (deferred: ng.IDeferred<IQuery[]>, college: College, course: Course) => {
        const isAlreadyProcessed =
          ngTransferCourseTransactionModel.ids.has(course.id) || ngTransferCoursesDatasource.get(course.id);
        if (isAlreadyProcessed) {
          deferred.resolve();
          return;
        }
        ngTransferCourseTransactionModel.ids.add(course.id);

        $http({
          method: 'POST',
          url: `student/college/${college.nk}/course`,
          data: {
            course: course.id
          }
        })
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            ngTransferCoursesDatasource.put(_.merge(course, response.data.results));
            transferMajorTileDelegate.updateDegreeAudit();
            deferred.resolve(QueryMediator.runQueries(ngTransferCoursesDatasource));
          })
          .catch(deferred.reject)
          .finally(() => {
            ngTransferCourseTransactionModel.ids.delete(course.id);
          });
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/select_transfer_course_command.ts